module.exports = __webpack_public_path__ + "static/media/ludo.9fa11a3e.png";